<template>
  <div class="heardertab">
    <ul class="heardertab-tab mb16">
      <li
        class="heardertab-tab-list"
        :class="{
          active: currentNum == index,
        }"
        v-for="(item, index) in tabList"
        :key="index"
        @click="tabClick(item, index)"
      >
        <div class="content">
          <div>{{ item.name }}</div>
          <div>数据统计情况</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "tab",
  props: ["currentNumN"],
  data() {
    return {
      role: [],
      tabList: [],
      currentNum: 0,
    };
  },
  methods: {
    // tab切换点击
    tabClick(data, index) {
      this.currentNum = index;
      this.$emit("tabNumChange", this.currentNum);
    },
  },
  mounted() {
    this.currentNum = this.currentNumN
    const routes = this.$router.options.routes;
    this.role = JSON.parse(localStorage.authority);
    routes.forEach((el) => {
      this.role.forEach((elc) => {
        if (elc.name == el.meta.name) {
          if (!this.tabList.length) {
            this.tabList = elc.child[0].child;
          }
        }
      });
    });
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
.heardertab {
  &-tab {
    display: flex;
    &-list {
      width: 253px;
      height: 134px;
      background: url(../../assets/tabunlight.png) no-repeat;
      background-size: 100% 100%;
      color: #363e51;
      cursor: pointer;
      .content {
        margin-top: 20px;
        margin-left: 30px;
        font-size: 14px;
        & > div:nth-child(1) {
          font-weight: bold;
        }
        & > div:nth-child(2) {
          font-size: 12px;
          margin-top: 10px;
        }
      }
    }
    .active {
      color: #ffffff !important;
      background: url(../../assets/tablight.png) no-repeat !important;
    }
  }
}
</style>
